import React, { useEffect } from "react"
import { firestoreConnect, isLoaded } from "react-redux-firebase"
import Presentation from "./Presentation"
import { compose } from "redux"
import { connect } from "react-redux"
import { loadTask ,setState} from "../../../../middleware/tasks"
import { unLinkTasks } from "../../../../middleware"

function Container(props) {

  const { taskData, _load_task, isLoadingTask } = props


  const [state, setState] = React.useState({
    listOfTasksToBeUnLinked: [],
  })

   let task = []

   let taskPayload = {
     taskID: props.taskId,
     projectID: props.projectId,
   }

   useEffect(() => {
     _load_task(taskPayload)
   }, [])

  const handleChange = (e, value) => {
    let taskArray = state.listOfTasksToBeUnLinked
    if (e.target.checked) {
      taskArray = [...taskArray, value]
    } else {
      const index = taskArray.indexOf(value)
      taskArray.splice(index, 1)
    }
    setState({
      ...state,
      listOfTasksToBeUnLinked: taskArray,
    })
  }
  const handleClick = (e,handleClose) => {
    e.preventDefault()
     const { unlink_task } = props
     let data = {
       tasksToBeUnlinked: state.listOfTasksToBeUnLinked,
       projectId: props.projectId,
     }
     let payload = {
       projectID: props.projectId,
       data,
     }
     console.log(payload)
     unlink_task(payload,handleClose)
    // dispatch({
    //   type: UNLINK_TASKS,
    //   payload: {
    //     tasksToBeUnlinked: state.listOfTasksToBeUnLinked,
    //     projectId: state.project.id,
    //   },
    // })
  }
  const clearValues = () => {
    setState({
      ...state,
      listOfTasksToBeUnLinked: "",
    })
  }
  if (isLoaded(props.project)) {
    if (!isLoadingTask) {
      task = Object.values(taskData["taskData"])
      return (
        <div>
          <Presentation
            {...props}
            listOfTasksToBeUnLinked={state.listOfTasksToBeUnLinked}
            task={task}
            handleChange={handleChange}
            handleClick={handleClick}
            clearValues={clearValues}
          />
        </div>
      )
    }
    else
      return <p>Loading</p>
  }
  return <p>Loading</p>
}

const mapStateToProps = (state, ownProps) => {
  const taskId = ownProps.taskId
  // const projectId = ownProps.projectId
  const tasksList = state.firestore.ordered.taskslist
  const project = state.firestore.ordered.project
  // ? state.firestore.ordered.project
  // : state.firestore.ordered.projectsList.filter(
  //     (item) => item.id === projectId
  //   )[0]

  return {
    taskData: state.projects.task,
    isLoadingTask: state.projects.task.taskData.isLoading,
    project: project,
    taskList: tasksList,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    _load_task: (payload) => {
      dispatch(loadTask(payload))
    },
    unlink_task: (payload,handleClose) => {
      dispatch(unLinkTasks(payload,handleClose))
    },
    // _un_subscribe_listener: (type) => dispatch(unSubscribeListener(type)),
    _set_state: (obj) => setState(obj),
  }
}
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    if (!props.task || !props.project)
      return [
        {
          collection: "PROJECTS",
          doc: props.projectId,
          storeAs: "project",
        },
        {
          collection: "PROJECTS",
          doc: props.projectId,
          subcollections: [
            {
              collection: "TASKS",
              storeAs: "tasks",
            },
          ],
          storeAs: "taskslist",
        },
      ]
    return []
  })
)(Container)
